// generated from 1_332 samples

import { z } from "zod";
import { common } from "../common";
import { filterGetBaseSchema } from "./filterGetBaseSchema";

export const birthdayFilterGetSchema = z.object({
  ...filterGetBaseSchema.shape,
  filter_key: z.literal("birthday_filter"),
  comparison_key: z.enum([
    "20", // 493 (37.01%)
    "15", // 268 (20.12%)
    "5", // 141 (10.59%)
    "3", // 131 (9.83%)
    "16", // 116 (8.71%)
    "1", // 101 (7.58%)
    "6", // 42 (3.15%)
    "4", // 40 (3.00%)
  ]),
  display_name: z.string(),
  // undefined: 273 (20.50%), defined 1_059 (79.50%)
  raw_value: z
    .union([
      // number samples: 408 (38.53%)
      // avg: 27.82, min: 0, max: 367
      z.int().min(0),
      // string samples: 651 (61.47%)
      common.date,
    ])
    .optional(),
  value: z.union([
    // number samples: 470 (35.29%)
    // integer: 469 (99.79%)
    // avg: 26.74, min: 0, max: 367
    z.number().min(0),
    // string samples: 862 (64.71%)
    common.date,
  ]),
  varies_by_app_group: z.literal(false),
});
